<template>
  <div class="padded">
    <el-row :style="'height: ' + height">
      <el-col align="center" :span="24">

        <events-calendar :events="selEvents" />

      </el-col>
    </el-row>

    <el-row>
      <el-col align="center" :span="24">
        <el-checkbox-group v-model="calview">
          <el-checkbox style="padding-left: 1em;" label="Maintenance" disabled no-form><span class="event-tickets event-legend">&nbsp;&nbsp;&nbsp;</span>&nbsp;Maintenance</el-checkbox>
          <el-checkbox style="padding-left: 1em;" label="Preventive" disabled no-form><span class="event-preventive event-legend">&nbsp;&nbsp;&nbsp;</span>&nbsp;Preventive</el-checkbox>
          <el-checkbox style="padding-left: 1em;" label="Equipment" disabled no-form><span class="event-assets event-legend">&nbsp;&nbsp;&nbsp;</span>&nbsp;Equipment</el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>

  </div>
</template>

<script>


import axios from '@/lib/axiosClient'

import EventsCalendar from '@/components/atoms/EventsCalendar'


export default {
  components: {
    EventsCalendar
  },

  props: {
    siteId: {
      type: String,
      default: ''
    },

    height: {
      type: String,
      default: '50%'
    }
  },

  methods: {

    eventSelected (event) {
      this.$root.$data.routes.push({name: 'Site', params: { id: event.data.siteId }})
    },

    getCalendar () {
      var url = this.getEndpoint('/calendar/tickets')

      axios.get(url).then(response => {
        this.selEvents = []

        for (let item in response.data) {
          let thing = {
            title: response.data[item].siteId + ' - ' + response.data[item].item,
            start: response.data[item].itemDate,
            end: response.data[item].itemDate,
            className: ['event-' + response.data[item].category.toLowerCase(), 'event-' + response.data[item].category.toLowerCase() + '-' + response.data[item].subCategory.toLowerCase()],
            data: response.data[item]
          }
          this.selEvents.push(thing)
        }
      })
      .catch(e => {
        console.error('X. Calendar error=', e)
        this.selEvents = []
      })
    }

  },


  data () {

    return {
      selEvents: [],
      calview: ['Maintenance']
    }

  },


  created () {
    this.getCalendar()
  }


}
</script>
